export const isAdmin = {
    get() {
        const is_admin = localStorage.getItem('is_admin');
        if (is_admin == 'true') {
            return true;
        }
        else {
            return false;
        }
    },
    set(is_admin) {
        localStorage.setItem('is_admin', is_admin);
    },
    delete() {
        localStorage.removeItem('is_admin');
    }
};